module.exports = __webpack_public_path__ + "img/wxmini.25159ce6.jpg";